import { useTranslation } from "react-i18next";
import "../../styles/LanguageSwitcher.css";

export default function LanguageSwitcher() {
  const { i18n, t } = useTranslation();

  const lang = i18n.language?.startsWith("uk") ? "uk" : "en";

  function changeLang(next) {
    i18n.changeLanguage(next);
  }

  return (
    <div className="langSwitcher">
      <div className="langTabs">
        <button
          type="button"
          className={`langTab ${lang === "uk" ? "active" : ""}`}
          onClick={() => changeLang("uk")}
        >
          {t("language.uk")}
        </button>

        <button
          type="button"
          className={`langTab ${lang === "en" ? "active" : ""}`}
          onClick={() => changeLang("en")}
        >
          {t("language.en")}
        </button>

        <span
          className="langIndicator"
          style={{
            transform: lang === "uk"
              ? "translateX(0)"
              : "translateX(73px)"
          }}
        />
      </div>
    </div>
  );
}